var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile"},[(!_vm.isEdditing)?_c('viewprofile',{attrs:{"profileid":_vm.profileid},on:{"editprofile":_vm.handleEdit}}):_c('editprofile',{on:{"editprofile":function($event){_vm.isEdditing = false}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }